import styled from "styled-components";
import { devices } from "src/utils/styled/_variables.styled";

export const SpacerWrapper = styled.section`
	div {
		display: block;
		width: 100%;
	}

	.spacer__mobile {
		@media ${devices.mfTablet} {
			display: none;
		}
	}

	.spacer__tablet {
		@media ${devices.mobile} {
			display: none;
		}

		@media ${devices.mfDesktop} {
			display: none;
		}
	}

	.spacer__desktop {
		@media ${devices.tablet} {
			display: none;
		}
	}
`;
